import { memo } from 'react';
import type { CSSProperties } from 'react';
import SText from '@/styles/SText';

interface DetailCellTextProps {
  text: string;
  style?: CSSProperties;
}

const DetailCellText = memo(function DetailCellText({ text, style }: DetailCellTextProps) {
  return <SText text={text} style={{ display: 'block', ...style }} />;
});

export default DetailCellText;
